import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faCreditCard, faUser, faUsers, faCircleNotch, faArrowRight} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate, Link, useLocation } from 'react-router-dom'
import Select from "react-select";

function Enrollment1() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [disable, setDisable] = useState(true);
  const [employer_id, setEmployer_id] = useState(state?.employer_id ?? localStorage.getItem('user.employer_id') ?? '');
  const [age, setAge] = useState(state?.age ?? localStorage.getItem('user.age') ?? '');
  const [contribution, setContribution] = useState(state?.contribution ?? localStorage.getItem('user.contribution') ?? '');
  const [salary, setSalary] = useState(state?.salary ?? localStorage.getItem('user.salary') ?? '');
  const [tax_type, setTax_type] = useState(state?.tax_type ?? localStorage.getItem('user.tax_type') ?? 'Pre-tax');
  const [effective_date, setEffective_date] = useState(state?.effective_date ?? localStorage.getItem('user.effective_date') ?? 'false');
  const [email, setEmail] = useState(localStorage.getItem('user.email') ?? '');
  const [userDetails, setUserDetails] = useState([]);
  useEffect(() => {
    if(!email || !employer_id || !age){
        navigate('/enrollment', { replace: true });
    }else{
        setLoading(false)
    }
  }, [email]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchuser1: true, email: email})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success" && data.user) {
            setUserDetails(data.user);
            setLoading(false);
        } else {
            setLoading(true);
        }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }, [email]);
  useEffect(() => {
    if(salary && contribution && tax_type && effective_date){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [salary, contribution, tax_type, effective_date]);

  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const taxoptions = [
    { value: "Pre-tax", label: "Pre-tax (Traditional)" },
    { value: "Roth", label: "Roth" },
  ];
  const payrolloptions = [
    { value: "false", label: "Next paycheck" },
    { value: "true", label: "Current paycheck" },
  ];

  if (loading || !userDetails || typeof userDetails !== 'object' || Object.keys(userDetails).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
    <div><Toaster/></div>
    <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
        Back to homepage
        </Link>
    </header>
    <main>
        <div className="container mt-5">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 mb-5">
                    <h5 className="mb-0" style={{fontWeight:'900'}}>401(k) Enrollment</h5>
                    <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                    <Link to="/enrollment" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                        <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Personal</p>
                    </Link>
                    <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                    <Link to="/enrollment1" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Contributions</p>
                    </Link>
                    <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                    <Link to="/enrollment2" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Investment</p>
                    </Link>
                    <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                    <Link to="/enrollment3" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faUsers} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Beneficiary</p>
                    </Link>
                    <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                    <Link to="/enrollment4" className="d-flex flex-column align-items-center noLink">
                        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                        <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                        </div>
                        <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review</p>
                    </Link>
                    </div>
                    <div className="mycard p-3 mt-4">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Monthly Salary</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="Monthly Salary"
                                        value={salary}
                                        onChange={(e) => setSalary(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Contribution % of pay</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="Contribution % of pay"
                                        value={contribution}
                                        onChange={(e) => setContribution(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Tax type</label>
                                    <Select 
                                        options={taxoptions} 
                                        value={taxoptions.find((opt) => opt.value === tax_type)}
                                        onChange={(e) => setTax_type(e.value)}
                                        styles={darkThemeStyles}
                                        className="w-full"
                                        placeholder="Tax type"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Payroll effective date</label>
                                    <Select 
                                        options={payrolloptions} 
                                        value={payrolloptions.find((opt) => opt.value === effective_date)}
                                        onChange={(e) => setEffective_date(e.value)}
                                        styles={darkThemeStyles}
                                        className="w-full"
                                        placeholder="Payroll effective date"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end">
                        {disable ? (
                            <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                        ) : (
                            <Link to="/enrollment2" state={{employer_id:employer_id, email:email, age:age, effective_date:effective_date, tax_type:tax_type, contribution:contribution, salary:salary}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => { 
                                localStorage.setItem('user.salary', salary);
                                localStorage.setItem('user.contribution', contribution);
                                localStorage.setItem('user.tax_type', tax_type);
                                localStorage.setItem('user.effective_date', effective_date);
                            }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </div>
  )
}

export default Enrollment1